import { render } from "./Menu.vue?vue&type=template&id=34d2ff69&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=34d2ff69&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34d2ff69"

export default script